import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../api/axiosInstance";

// ----------- Async Thunk (TEST OTO Connection) -----------
export const testOtoConnection = createAsyncThunk(
  "otoSettings/testConnection",
  async (data, thunkAPI) => {
    try {
      const response = await api.post("/dashboard/general-settings/oto-settings/test-connection", data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ----------- Slice -----------
const testOtoConnectionSlicer = createSlice({
  name: "testOtoConnection",
  initialState: {
    testResult: null,
    loading: false,
    error: null,
    successMessage: "",
  },
  reducers: {
    clearTestOtoConnectionState: (state) => {
      state.testResult = null;
      state.loading = false;
      state.error = null;
      state.successMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(testOtoConnection.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(testOtoConnection.fulfilled, (state, action) => {
        state.loading = false;
        state.testResult = action.payload.data;
        state.successMessage = action.payload?.message || "";
      })
      .addCase(testOtoConnection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearTestOtoConnectionState } = testOtoConnectionSlicer.actions;
export default testOtoConnectionSlicer.reducer;
